import type { WindowKey } from "owa-bizchat-types";
import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

export const removeTasksHubWindowMutator: (windowKey: WindowKey) => void = mutatorAction("removeTasksHubWindow", (windowKey: WindowKey) => {
    getStore().activeWindows.delete(windowKey);
});
